<ng-container *ngIf="hasNotificationsToShow | async">
  <div class="notification-flash">
    <ftr-notification *ngFor="let notification of notifications | async" [type]="notification.type">
      <div markdown>{{ notification.message }}</div>
    </ftr-notification>
  </div>
</ng-container>
